import type { Category } from '@/payload-types'

/**
 * Build the URL for a category nav link / card.
 *
 * SEO fix (CODE-04, Wave 2): navigation and the homepage category grid
 * used to hardcode `/shop?category=${id}` for every category link — every
 * category page in the header, homepage "Kategorien" grid, and mobile
 * menu. Meanwhile the site *also* has clean, indexable slug routes for
 * categories (e.g. `/de/kingsize`, handled by `[locale]/[slug]/page.tsx`),
 * but nothing ever linked to them internally. That left them essentially
 * orphaned from Google's perspective — no internal links, and previously
 * not in the sitemap either. Point nav links at the slug route instead so
 * the pages we actually want to rank for things like "kingsize papers"
 * get real internal link equity.
 *
 * Falls back to the old `/shop?category=${id}` query-string form when a
 * category doesn't have a resolvable slug (e.g. only a bare numeric ID was
 * stored, not a populated relationship) so nothing breaks if depth/population
 * ever changes upstream.
 *
 * Ported from stamm-baum.at/v3/src/utilities/categoryHref.ts (2026-07-26).
 */
export function getCategoryHref(
  categoryId: number | string | Category | null | undefined,
  fallbackUrl?: string | null,
): string {
  if (categoryId && typeof categoryId === 'object') {
    if (categoryId.slug) return `/${categoryId.slug}`
    return `/shop?category=${categoryId.id}`
  }
  if (categoryId) {
    return `/shop?category=${categoryId}`
  }
  return fallbackUrl || '#'
}
